import { EXTEND_GLOBAL_DIALOG } from '@glass/web/modules/globalDialog';

export type Payload = {
  confirmLoading?: boolean;
};

const extendGlobalDialogAction = (payload: Payload) => ({
  type: EXTEND_GLOBAL_DIALOG,
  payload,
});

export default extendGlobalDialogAction;
